var Model = require("../../../types/Model.js");
var log = require("../../../../utils/BluetoothLog").logState;

var CONNECTION_TIMEOUT = 15 * 1000;
var WAITING_TIMEOUT = 30 * 1000;
var READING_TIMEOUT = 2 * 30 * 1000;

var DEVICES = [
	"deviceNonin3230",
	"deviceForaSPO2",
	"deviceIHO2"
];

var DEVICE_MAP = {
	"nonin": "deviceNonin3230",
	"foraspo2": "deviceForaSPO2",
	"ihspo2": "deviceIHO2"
};

var MODEL_MAP = {
	"deviceNonin3230": "Nonin3230",
	"deviceForaSPO2": "TNG SPO2",
	"deviceIHO2": "MD300CI218"
};

module.exports = new Model({
	name: "deviceoxygen",
	listeners,
	triggers,
	init,
	uninit,

	info,
	clean,
	begin,
	cleanState,
	readDevice,
	handleDisconnect,
	handleDeviceFailed,
	handleConnectionFailed,
	handleProgressUpdated,
});

function triggers(){
	return {
		"showinfo": info,
		"workflow": workflow,
		"begin": begin,
		"clean": clean
	};
}

function listeners(){
	return DEVICES.reduce((acc, device) => {
		acc[`${device}:done`] = handleDone;
		acc[`${device}:battery`] = handleBattery;
		acc[`${device}:hasRead`] = handleHasRead;
		return acc;
	}, {
		"bluetooth:scanned": handleScanned,
		"bluetooth:connected": handleDeviceConnected,
		"bluetooth:failed": handleDeviceFailed,
		"bluetooth:disconnected": handleDeviceDisconnected,
		"owndevices:updated": handleDevicesUpdate,
		"atouchawaysettings:updated": handleSettingsUpdate,
		"activemanagegroup:updated": handleManageGroupUpdated
	});
}

function init(){
	this._isWorkflow = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasDisconnected = false;
	this._hasRead = false;
	this._ignoreEvents = true;
	this._hasFailed = false;
	this._progress = 0;

	this._managed = null;
	this._deviceType = null;
	this._deviceMac = null;
	this._timer = null;

	this._retryConnect = 0;

	this._readingTimeout = null;
	this._waitingTimeout = null;
	this._connectionTimeout = null;
}

function uninit(){
	this._isWorkflow = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasDisconnected = false;
	this._hasRead = false;
	this._ignoreEvents = false;
	this._hasFailed = false;
	this._progress = 0;

	this._managed = null;
	this._deviceType = null;
	this._deviceMac = null;

	this._retryConnect = 0;

	clearInterval(this._timer);
	this._timer = null;

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	clearTimeout(this._waitingTimeout);
	this._waitingTimeout = null;
	this._readingTimeout = null;
	this._connectionTimeout = null;
}

function workflow(){
	this._isWorkflow = true;
	// log(this, "OxygenWorkflow", this);
	this.info();
}

function info(data){
	var macs = this._assignedMacs || {};

	var first = Object.keys(macs)[0];
	var firstDevice = macs[first] || {};
	var device = firstDevice.model || "nonin";
	if(data && data.who) this._managed = data.who;

	var model = DEVICE_MAP[device];
	this._deviceType = model;

	this.emit(`${model}:trigger:info`);
	this.emit("bluetooth:trigger:initialize");
	// log(this, "Oxygeninfo", this);
}

function begin(){
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.reading_from_device",
		items: {
			connect: {
				type: "load",
				progress: 0,
				message: "myhealthdevice.connecting"
			},
			wait: { },
			reading: {
				type: "progress",
				progress: 0,
				message: "myhealthdevice.reading",
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "begin read from device for blood oxygen", {
		"device type": this._deviceType || "nonin",
	});
	this.readDevice();
}

function readDevice(){
	this._isScanning = true;
	this._ignoreEvents = false;

	this._connectionTimeout = setTimeout(handleConnectionFailed.bind(this), CONNECTION_TIMEOUT);

	this.emit("bluetooth:trigger:scan");
	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.scanning"
		}
	});
}

function handleScanned(scanned){
	var isScanning = this._isScanning;

	if(this._ignoreEvents) return;

	var macs = this._assignedMacs;
	var macKeys = Object.keys(macs);
	var isMacs = macKeys.length;
	var macExists = macKeys.indexOf(scanned.id) !== -1;

	var model = MODEL_MAP[this._deviceType];

	if(!isScanning) return;
	if(!(scanned && scanned.name && scanned.name.indexOf(model) !== -1)) return;
	if(isMacs && !macExists) return;

	var found = scanned.id;
	this._isScanning = false;
	this._isConnecting = true;
	this._deviceMac = found;

	// log(this, "OxygenScanned", this);
	this.emit("bluetooth:trigger:scan:stop");
	this.emit("bluetooth:trigger:connect", {
		mac: found,
		model: model
	});

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 0,
			type: "load",
			message: "myhealthdevice.connecting"
		}
	});
}

function handleDeviceConnected(){
	var isConnecting = this._isConnecting;
	if(!isConnecting || this._ignoreEvents) return;
	this._isConnecting = false;
	this._hasConnected = true;

	clearTimeout(this._connectionTimeout);
	this._readingTimeout = setTimeout(handleDeviceFailed.bind(this), READING_TIMEOUT);

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.connected"
		},
		wait: {
			type: "progress",
			progress: 0,
			message: "myhealthdevice.wait",
			bold: true
		},
	});

	// log(this, "OxygenConnected", this);
	this._timer = setInterval(handleProgressUpdated.bind(this), 2000);
	this._waitingTimeout = setTimeout(startRead.bind(this), WAITING_TIMEOUT);
}

function startRead(){
	var device = this._deviceType;
	clearInterval(this._timer);
	clearTimeout(this._waitingTimeout);

	this.emit("feedbackmodal:trigger:update", {
		wait: {
			type: "progress",
			progress: 1,
			message: "myhealthdevice.wait",
			bold: true
		}
	});

	this.emit(`${device}:trigger:ready`, {
		mac: this._deviceMac
	});
}

function handleDone(reading){
	var isWorkflow = this._isWorkflow;
	var shouldFollowUp = this._postFollowUp;
	var managed = this._managed;
	var manageGroup = this._manageGroup;
	if(!reading) return;

	this._hasFinishedReading = true;
	clearTimeout(this._readingTimeout);
	clearTimeout(this._waitingTimeout);
	// log(this, "OxygenDone", this);

	var processReading = noop;
	if(isWorkflow) {
		processReading = handleWorkflow.bind(this);
	} else if(shouldFollowUp) {
		processReading = sendReadingToFollowUp.bind(this);
		reading.type = "bloodoxygen";
		if(managed) {
			reading.who = managed;
			if(manageGroup)
				reading.group = manageGroup;
		}
	} else if(managed){
		reading.managerId = managed;
		if(manageGroup)
			reading.group = manageGroup;
		processReading = this.api.manage.bloodoxygen.add;
	} else {
		processReading = this.api.device.bloodoxygen.add;
	}

	return processReading(reading).then(() => {
		setTimeout(handleDisconnect.bind(this, 3000));
	}).catch(handleDeviceFailed.bind(this));
}

function handleDisconnect(){
	var hasConnected = this._hasConnected;
	var hasDisconnected = this._hasDisconnected;
	var deviceMac = this._deviceMac;

	// log(this, "OxygenDisconnect", this);
	if(hasConnected && !hasDisconnected){
		this._hasConnected = false;
		this.emit("bluetooth:trigger:disconnect", {
			mac: deviceMac
		});
	} else if (hasConnected && hasDisconnected)
		this.clean();

}

function handleDeviceDisconnected(){
	var hasFinishedReading = this._hasFinishedReading;
	var hasRead = this._hasRead;
	var deviceType = this._deviceType;

	if(this._ignoreEvents) return;

	this._hasDisconnected = true;
	if(deviceType)
		this.emit(`${deviceType}:trigger:disconnect`);

	if(hasRead) return;

	// log(this, "OxygenDisconnected", this);
	if(hasFinishedReading) this.clean();
	else this.handleDeviceFailed();
}

function handleHasRead(){
	this._hasRead = true;
}

function clean(){
	this.emit("feedbackmodal:trigger:hide");
	if(this._isScanning) this.emit("bluetooth:trigger:scan:stop");
	if(this._deviceType) this.emit(`${this._deviceType}:trigger:clean`);
	if(!this._hasFailed)
		log(this, "OxygenSuccess", this);
	else
		log(this, "OxygenFailed", this);
	// log(this, "OxygenClean", this);
	this.cleanState();
}

function cleanState(){
	this._isWorkflow = false;
	this._isScanning = false;
	this._isConnecting = false;
	this._hasConnected = false;
	this._hasFinishedReading = false;
	this._hasDisconnected = false;
	this._hasRead = false;
	this._ignoreEvents = true;
	this._hasFailed = false;
	this._progress = 0;

	this._deviceMac = null;

	this._retryConnect = 0;

	clearInterval(this._timer);
	this._timer = null;

	clearTimeout(this._connectionTimeout);
	clearTimeout(this._readingTimeout);
	clearTimeout(this._waitingTimeout);
	this._waitingTimeout = null;
	this._readingTimeout = null;
	this._connectionTimeout = null;
	// log(this, "OxygenCleaned", this);
}

function handleConnectionFailed(){
	var retried = ++this._retryConnect;
	clearTimeout(this._connectionTimeout);

	// log(this, "OxygenConnectionTimeout", this);
	if(retried <= 2) this.readDevice();
	else this.handleDeviceFailed();
}

function handleDeviceFailed(){
	var deviceType = this._deviceType;
	var isScanning = this._isScanning;
	var isConnecting = this._isConnecting;
	var hasConnected = this._hasConnected;
	var retryConnect = this._retryConnect;
	var isWorkflow = this._isWorkflow;

	if(this._ignoreEvents) return;

	if((isScanning || isConnecting) && retryConnect <= 2)
		return this.handleConnectionFailed();

	if(!(isScanning || isConnecting || hasConnected)) return;

	// log(this, "OxygenDeviceFailed", this);
	this._hasFailed = true;
	if(deviceType) this.emit(`${deviceType}:trigger:failed`);
	else this.emit("deviceNonin3230:trigger:failed");

	if(!this._hasDisconnected)
		this.handleDisconnect();

	this.clean();
	this._isWorkflow = isWorkflow;
}

function handleBattery(reading){
	var deviceMac = this._deviceMac;

	this.emit("feedbackmodal:trigger:update", {
		connect: {
			progress: 1,
			type: "load",
			message: "myhealthdevice.batterylevel",
			messageArgs: {
				battery: reading
			}
		}
	});

	var assignedMacs = this._assignedMacs;
	var keys = Object.keys(assignedMacs);

	if(!keys.length) return;
	var device = assignedMacs[deviceMac];
	if(!device) return;


	// log(this, "OxygenBattery", this);
	return this.api.devices.battery(device._id, reading);
}

function handleWorkflow(reading){
	// eslint-disable-next-line compat/compat
	return new Promise((resolve) => {
		var legible = legibleReading(reading);
		this.dispatch("reading", {
			legible: legible,
			value: reading
		});
		resolve();
	});
}

function handleDevicesUpdate(data){
	var list = data.list;

	var newMacs = list.reduce((acc, device) => {
		if(device.device_type === "spo2")
			acc[device.mac] = device;
		return acc;
	}, {});

	this._assignedMacs = newMacs;
}

function legibleReading(readings) {
	return readings.pulserate + " bpm, " + readings.oxygensaturation + "%";
}

function handleSettingsUpdate(data){
	this._postFollowUp = (data || {}).postbloodoxygen;
}

function sendReadingToFollowUp(reading){
	// eslint-disable-next-line compat/compat
	return new Promise(function(resolve){
		this.emit("devicefollowup:trigger:show", reading);
		resolve(reading);
	}.bind(this));
}

function noop(data){
	// eslint-disable-next-line compat/compat
	return new Promise(function(resolve){
		resolve(data);
	});
}

function handleManageGroupUpdated(group){
	this._manageGroup = group;
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < 15)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		wait: {
			type: "progress",
			progress: progress / 15,
			message: "myhealthdevice.wait",
			bold: true
		}
	});

	this._progress = progress;
}